import React from 'react';
import { ServiceErrorMessage } from '@mo/service-error-message';
import styles from './technicalError.module.scss';
import { ReactComponent as WarningIcon } from './warning.svg';

export const TechnicalError: React.FunctionComponent = (props) => {
    return (
        <ServiceErrorMessage
            visible={true}
            title='A technical error happened'
            className={styles.technicalError}
            hintClassName={styles.technicalErrorHint}
            titleClassName={styles.technicalErrorTitle}
            messageClassName={styles.technicalErrorMessage}
            icon={<WarningIcon />}
        >
            <>{props.children}</>
        </ServiceErrorMessage>
    );
};
